import React, { Component } from "react";
import AMISERVICE from "../services/ami.service";
import { TextField, Button, withStyles } from "@material-ui/core"
import { styles } from "../css-common"
import 'bootstrap/dist/css/bootstrap.min.css';
import myimage from "../../src/assets/images/logo.png";
import loaderimage from "../../src/assets/images/loader.gif";
import loader from "../../src/assets/images/load.gif";
import DataTable from 'react-data-table-component';
import { MDBTypography } from "mdb-react-ui-kit";
import HorizontalScroll from 'react-horizontal-scrolling';
class AddTutorial extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: null,
            title: "",
            description: "",
            published: false,
            showTable: 'none',
            submitted: false,
            displayLoader: 'none',
            displayTable: 'none',
            rows: [],
            lastStatus: '',
            trackId: '',
            trackProgress: [],
            ftrackID:''
        };
        sessionStorage.removeItem('rowClickTrackEventDetails');
    }
     TrackDetails(id,e) {
        console.log(id);
        console.log("test2");
        sessionStorage.setItem("rowclick",e)
        if('btn'==sessionStorage.getItem("rowclick"))
        {
            sessionStorage.removeItem('rowClickTrackEventDetails');
            
        }
        console.log("on click",sessionStorage.getItem("rowclick",e))
        this.state.trackProgress=[]
            this.setState({
                displayLoader: '',
                displayTable: 'none',
    
            })
            AMISERVICE.get(id)
                .then(response => {
                    var loadData = []
                    //loadData = response.data
                    if (response.data.length > 0) {
                        response.data.map((item) => {
                            var findItem = loadData.find((x) => x.TrackEventDetails === item.TrackEventDetails);
                            if (!findItem) loadData.push(item);
                        });
                        //   console.log("Loding ka data",loadData)
                        loadData.forEach
                            ((item) => {
                                this.state.trackProgress.push({ Id: item.Id, TrackEventDetails: item.TrackEventDetails })
                            });
                        this.setState({
                            rows: loadData,
                            displayLoader: 'none',
                            displayTable: '',
                            lastStatus: loadData[0]['TrackEventDetails'],
                            trackId: loadData[0]['EtrackID'],
                            trackProgress:this.state.trackProgress.reverse(),
                            ftrackID:loadData[0]['ExternalTrackingID']
                        })
                    }
                    else {
                        alert("No tracking data found.")
                        this.setState({
                            displayLoader: 'none',
                            rows: []
                        })
                    }
                })
                .catch(e => {
                    console.log(e);
                });
            console.log(this.state.rows)
           
      }
      rowclickmeri(ExternalTrackingID,e){
        sessionStorage.setItem("rowClickTrackEventDetails",e.TrackEventDetails)
        //var odSubValue = ExternalTrackingID.substring(0, 3)=="019"?ExternalTrackingID.substring(0, 3):ExternalTrackingID.substring(0, 2);
        var odSubValue = ExternalTrackingID.substring(0, 3)=="019"?ExternalTrackingID.substring(0, 3):ExternalTrackingID.substring(0, 1)=="X"?ExternalTrackingID.substring(0, 1):ExternalTrackingID.substring(0, 2);

        this.setState({
            displayLoader: '',
            displayTable: 'none',

        })
        console.log(process.env.REACT_APP_TrackingNo_StartWithNE);
        switch (odSubValue) {
            case process.env.REACT_APP_TrackingNo_StartWith019:
               // window.open(process.env.REACT_APP_TrackingUrl019 + this.state.trackId, '_blank');
                window.open(process.env.REACT_APP_TrackingUrl019 + ExternalTrackingID.slice(18,39), '_blank');

                break;
            case process.env.REACT_APP_TrackingNo_StartWithBJ:
                window.open(process.env.REACT_APP_TrackingUrloth + ExternalTrackingID, '_blank');
                break;
            case process.env.REACT_APP_TrackingNo_StartWithK7:
                window.open(process.env.REACT_APP_TrackingUrloth + ExternalTrackingID, '_blank');
                break;
            case process.env.REACT_APP_TrackingNo_StartWithMP:
                window.open(process.env.REACT_APP_TrackingUrloth + ExternalTrackingID, '_blank');
                break;
                case process.env.REACT_APP_TrackingNo_StartWithMX:
                case process.env.REACT_APP_TrackingNo_StartWithX:
                    window.open(process.env.REACT_APP_TrackingUrlMX + ExternalTrackingID, '_blank');
                break;
            case process.env.REACT_APP_TrackingNo_StartWithNE:
                window.open(process.env.REACT_APP_TrackingUrlNEX + ExternalTrackingID, '_blank');
                break;

            }
              
                this.TrackDetails(ExternalTrackingID,'rowclick')
      }
   
    render() {
        const { classes } = this.props;
        const columns = [
            {
                name: 'Tracking ID',
                selector: row => row.EtrackID,
                width: "200px",
                ignoreRowClick:true
            },
            {
                name: 'Final Mile Tracking Number',
                selector: row => row.ExternalTrackingID,
                width: "350px" 
            },
            {
                name: 'Shipment Location',
                selector: row => row.City,
                ignoreRowClick:true
                
            },
            {
                name: 'Local Time',
                selector: row => row.EventDateOccured,
                ignoreRowClick:true

            }, {
                name: 'Tracking Events',
                selector: row => row.TrackEventDetails,
                ignoreRowClick:true
            }
        ]
        

        return (
            <React.Fragment>
                <section className="trac-header-section">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-3">
                                <div className="trac-logo">
                                    <img src={myimage} alt="logo"></img>

                                </div>
                            </div>
                            <div className="col-4 ms-auto">
                                <form className="d-flex mt-2">
                                    <div class="">
                                        <div className={classes.textField}>
                                            <TextField
                                                // disabled
                                               // label={this.state.trackId}
                                                name="title"
                                                value={this.state.title}
                                                onChange={e=>this.setState({title:e.target.value})}
                                                variant="outlined"
                                            />
                                        </div>
                                        </div>
                                        <Button onClick={() => this.TrackDetails(this.state.title,'btn')} variant="contained" color="primary"> search</Button>
                                        
                                </form>
                            </div>
                        </div>
                    </div>
                </section>
                <div class="container padding-bottom-3x mb-1">
                    <div class="card mb-3">
                        <div class="p-4 text-center text-white text-lg bg-dark rounded-top"><span class="text-uppercase">Shipment Progress</span></div>
                        <div class="d-flex flex-wrap flex-sm-nowrap justify-content-between py-3 px-2  stepper-subhead">
                            {/* <div class="w-100 text-center py-1 px-2"><span class="text-medium">Shipped Via:</span> e Retail logistics</div> */}
                            <div class="w-100 text-center py-1 px-2"><span class="text-medium">Status:</span> {this.state.lastStatus}</div>
                            <div class="w-100 text-center py-1 px-2">Need help <span class="text-medium">
                                <a href="mailto: customerservice@amservices.net.au">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-circle" viewBox="0 0 16 16">
                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                        <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z" />
                                    </svg>
                                </a>
                            </span>
                            </div>
                        </div>
                        <div className="px-3 mt-3 d-flex justify-content-between align-items-center mb-5">
                        </div>
                        <div class="card-body ">
                            <div class="steperscroll steps d-flex flex-wrap flex-sm-nowrap justify-content-between padding-top-2x padding-bottom-1x">
                                {this.state.trackProgress.map((x) => (
                                    <div class={x.TrackEventDetails == sessionStorage.getItem("rowClickTrackEventDetails") ? "step active completed": "step completed"}>
                                        <div class="step-icon-wrap ">
                                            <div class={this.state.trackProgress.indexOf(x) == 0 || x.TrackEventDetails == "Delivered" ? "step-icon big-icon" : "step-icon"}>
                                                <div className={this.state.trackProgress.indexOf(x) == 0 || (this.state.trackProgress.indexOf(x) == this.state.rows.length - 1 && x.TrackEventDetails == "Delivered")  ? "" : (this.state.trackProgress.indexOf(x) == this.state.rows.length - 1 && x.TrackEventDetails != "Delivered")? "step-iconInner step-icon-wrap3" : "step-iconInner"}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width={this.state.trackProgress.indexOf(x) == 0 || (this.state.trackProgress.indexOf(x) == this.state.rows.length - 1 && x.TrackEventDetails == "Delivered") ? "30" : "20"} height={this.state.trackProgress.indexOf(x) == 0 || this.state.trackProgress.indexOf(x) == this.state.rows.length - 1 ? "40" : "20"} fill="currentColor" class="bi bi-gear" viewBox="0 0 16 16">
                                                        <path d={this.state.trackProgress.indexOf(x) == 0 || (this.state.trackProgress.indexOf(x) == this.state.rows.length - 1 && x.TrackEventDetails == "Delivered") ? "M0 3.5A1.5 1.5 0 0 1 1.5 2h9A1.5 1.5 0 0 1 12 3.5V5h1.02a1.5 1.5 0 0 1 1.17.563l1.481 1.85a1.5 1.5 0 0 1 .329.938V10.5a1.5 1.5 0 0 1-1.5 1.5H14a2 2 0 1 1-4 0H5a2 2 0 1 1-3.998-.085A1.5 1.5 0 0 1 0 10.5v-7zm1.294 7.456A1.999 1.999 0 0 1 4.732 11h5.536a2.01 2.01 0 0 1 .732-.732V3.5a.5.5 0 0 0-.5-.5h-9a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .294.456zM12 10a2 2 0 0 1 1.732 1h.768a.5.5 0 0 0 .5-.5V8.35a.5.5 0 0 0-.11-.312l-1.48-1.85A.5.5 0 0 0 13.02 6H12v4zm-9 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm9 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2z" : ""} />
                                                    </svg>
                                                </div>
                                            </div>
                                        </div>
                                        <h4 class="step-title">{x.TrackEventDetails}</h4>
                                    </div>
                                ))}
                            </div>
                            <div style={{ display: this.state.displayTable }}>
                                <DataTable
                                className="trc-table-data"
                                columns={columns}
                                data={this.state.rows}
                                onRowClicked={(e)=>this.rowclickmeri(this.state.ftrackID,e)}
                                pagination
                            /></div>
                            <br></br>
                            <div style={{ display: this.state.displayLoader }}>
                                <img src={loaderimage} alt="logo" style={{ marginLeft: '46%' }} ></img></div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}
export default withStyles(styles)(AddTutorial)